import { getValue, update } from '@kundinos/nanostores';
import equal from 'fast-deep-equal';

import { dataStore, initialParametersStore, currentParametersStore, modulesStore } from './stores';

import type { DataStoreValue } from './stores';

const init = (initialValue: DataStoreValue): void => {
  const value = getValue(dataStore);

  if (initialValue && !equal(initialValue, value)) {
    // Основная информация
    dataStore.set({ ...initialValue, blocked: true });

    // Параметры
    initialParametersStore.set(initialValue.parameters);
    currentParametersStore.set(initialValue.parameters);

    // Модули
    modulesStore.set(initialValue.modules);

    // Инициализация закончена
    update(dataStore, (prev) => ({ ...prev, blocked: false }));
  }
};

export default init;
